import { render, staticRenderFns } from "./ContentBg.vue?vue&type=template&id=6290eb4c&scoped=true"
import script from "./ContentBg.vue?vue&type=script&lang=js"
export * from "./ContentBg.vue?vue&type=script&lang=js"
import style0 from "./ContentBg.vue?vue&type=style&index=0&id=6290eb4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6290eb4c",
  null
  
)

export default component.exports